var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompaniesPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 174,
    viewBox: "0 0 174 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 84,
    width: 46,
    height: 62,
    fill: "#F2F2F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 53,
    width: 46,
    height: 93,
    fill: "#EBEBEB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 93,
    width: 9,
    height: 8,
    fill: "#E4E2E2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 70,
    width: 9,
    height: 8,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 60,
    width: 32,
    height: 4,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 45,
    width: 38,
    height: 8,
    fill: "#F5B953"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 76,
    width: 38,
    height: 8,
    fill: "#F5B953"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 107,
    width: 24,
    height: 39,
    fill: "#BDBDBD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 87,
    width: 9,
    height: 8,
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 103,
    width: 9,
    height: 8,
    fill: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 120,
    width: 9,
    height: 8,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 113,
    width: 4,
    height: 4,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 122,
    width: 4,
    height: 4,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 130,
    width: 4,
    height: 4,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 138,
    width: 4,
    height: 4,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 113,
    width: 4,
    height: 4,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 122,
    width: 4,
    height: 4,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 130,
    width: 4,
    height: 4,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 138,
    width: 4,
    height: 4,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 109,
    width: 9,
    height: 8,
    fill: "#E4E2E2"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 125,
    width: 9,
    height: 8,
    fill: "#E4E2E2"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 93,
    width: 9,
    height: 8,
    fill: "#E4E2E2"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 70,
    width: 9,
    height: 8,
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 87,
    width: 9,
    height: 8,
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 103,
    width: 9,
    height: 8,
    fill: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 120,
    width: 9,
    height: 8,
    fill: "white"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 136,
    width: 21,
    height: 10,
    fill: "#F5B953"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 109,
    width: 9,
    height: 8,
    fill: "#E4E2E2"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 125,
    width: 9,
    height: 8,
    fill: "#E4E2E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompaniesPic);
export default __webpack_public_path__ + "static/media/companiesPic.20543b1cc7c53e83a14c5656bcb73a78.svg";
export { ForwardRef as ReactComponent };